import React from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";

import CopyBlock from "../CopyBlock";

import "react-accessible-accordion/dist/fancy-example.css";
import * as accordionStyles from "./Accordion.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

const _Accordion = ({ props }) => {
  const { items } = props;

  return (
    <Accordion allowZeroExpanded className={accordionStyles.accordions}>
      {items.map((item, index) => (
        <AccordionItem
          // data-aos="zoom-in-up"
          // data-aos-duration="400"
          key={index}
          className={accordionStyles.accordion}
          itemscope
          itemprop="mainEntity"
          itemtype="https://schema.org/Question"
        >
          <AccordionItemHeading itemprop="name">
            <AccordionItemButton className={accordionStyles.button}>
              {item.heading}
              <FontAwesomeIcon icon={faChevronDown} size="lg" />
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel
            className={accordionStyles.panel}
            itemscope
            itemprop="acceptedAnswer"
            itemtype="https://schema.org/Answer"
          >
            <CopyBlock itemprop="text" props={item.details} />
          </AccordionItemPanel>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default _Accordion;
